import { render, staticRenderFns } from "./PrkTableHeadline.vue?vue&type=template&id=606b6822&scoped=true&"
import script from "./PrkTableHeadline.vue?vue&type=script&lang=js&"
export * from "./PrkTableHeadline.vue?vue&type=script&lang=js&"
import style0 from "./PrkTableHeadline.vue?vue&type=style&index=0&id=606b6822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b6822",
  null
  
)

export default component.exports